// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resultModal .speedometer .current-value {
  fill: #333333 !important;
}
.resultModal .observation-list .list-unstyled li {
  position: relative;
  padding-left: 15px;
}
.resultModal .observation-list .list-unstyled li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.resultModal .observation-list .list-unstyled.one-list li::before {
  background: #F05D70;
}
.resultModal .observation-list .list-unstyled.two-list li::before {
  background: #ff471a;
}
.resultModal .nav-pills {
  border: 1px solid #212B65;
  border-radius: 30px;
  margin: 0;
  padding: 3px;
}
.resultModal .nav-pills .nav-item {
  display: inline-block;
}
.resultModal .nav-pills .nav-item {
  margin-right: 2px;
}
.resultModal .nav-pills .nav-item:last-child {
  margin-right: 0;
}
.resultModal .nav-pills .nav-item .nav-link {
  text-align: center;
  color: #212B65;
  transition: all 0.2s linear;
  padding: 0.35rem 0.5rem;
}
.resultModal .nav-pills .nav-item .nav-link.active {
  color: #ffffff;
  font-weight: 600;
  border-radius: 30px;
  background-color: #212B65 !important;
}
.resultModal .examWise,
.resultModal .chapterWise {
  margin-bottom: 0;
}
.resultModal .examWise th,
.resultModal .examWise td,
.resultModal .chapterWise th,
.resultModal .chapterWise td {
  padding: 6px 12px;
}
.resultModal .examWise thead th,
.resultModal .chapterWise thead th {
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
}
.resultModal .examWise tbody td + td,
.resultModal .chapterWise tbody td + td {
  font-weight: 600 !important;
}
.resultModal table.examWise th + th,
.resultModal table.examWise td + td,
.resultModal table.chapterWise th + th,
.resultModal table.chapterWise td + td {
  border-left: 1px solid rgba(0, 0, 0, 0.1254901961);
}
.resultModal .errorTitle {
  background-color: #E1F2FF;
  padding-top: 15px !important;
}
.resultModal .errorTitle .errorText {
  writing-mode: vertical-rl;
  transform: rotate(179deg);
}
.resultModal .correctComplexitytable .react-bootstrap-table .table th + th,
.resultModal .correctComplexitytable .react-bootstrap-table .table td + td {
  border-left: 1px solid rgba(0, 0, 0, 0.1254901961);
}
.resultModal .correctComplexitytable .react-bootstrap-table .table thead {
  background: #ffffff !important;
}
.resultModal .correctComplexitytable .react-bootstrap-table .table thead th:nth-child(2) {
  color: #28a745 !important;
}
.resultModal .correctComplexitytable .react-bootstrap-table .table thead th:nth-child(3) {
  color: #dc3545 !important;
}
.resultModal .correctComplexitytable .react-bootstrap-table .table thead th:nth-child(4) {
  color: #ffc107 !important;
}
.resultModal .correctComplexitytable .react-bootstrap-table .table tbody td {
  color: #142031;
  font-weight: 600 !important;
}
.resultModal .correctComplexitytable .react-bootstrap-table .table tbody td:first-child {
  font-weight: 400 !important;
}
.resultModal .questionTypetable .react-bootstrap-table .table th + th,
.resultModal .questionTypetable .react-bootstrap-table .table td + td {
  border-left: 1px solid rgba(0, 0, 0, 0.1254901961);
}
.resultModal .questionTypetable .react-bootstrap-table .table tbody td {
  color: #142031;
  font-weight: 600 !important;
}
.resultModal .questionTypetable .react-bootstrap-table .table tbody td:first-child {
  font-weight: 400 !important;
}
.resultModal .resultsortingtable .table td,
.resultModal .resultsortingtable .table th {
  color: #142031 !important;
  border-right: 1px solid rgba(0, 0, 0, 0.1254901961);
}
.resultModal .resultsortingtable .table td:last-child,
.resultModal .resultsortingtable .table th:last-child {
  border-right: none;
}
.resultModal .resultsortingtable .table thead {
  background: #ffffff !important;
}
.resultModal .resultsortingtable .table thead th:nth-child(2) {
  color: #36A1F5 !important;
}
.resultModal .resultsortingtable .table thead th:nth-child(3) {
  color: #00C596 !important;
}
.resultModal .resultsortingtable .table thead th:nth-child(4) {
  color: #F05D70 !important;
}
.resultModal .resultsortingtable .table thead th:nth-child(5) {
  color: #DF7E00 !important;
}
.resultModal .resultsortingtable.chapter_wisetable .table td,
.resultModal .resultsortingtable.chapter_wisetable .table th {
  border-right: 1px solid rgba(0, 0, 0, 0.1254901961);
}
.resultModal .resultsortingtable.chapter_wisetable .table td:last-child,
.resultModal .resultsortingtable.chapter_wisetable .table th:last-child {
  border-right: none;
}
.resultModal .resultsortingtable.chapter_wisetable .table thead {
  background: #ffffff !important;
}
.resultModal .resultsortingtable.chapter_wisetable .table thead th:nth-child(2) {
  color: #ac072b !important;
}
.resultModal .resultsortingtable.chapter_wisetable .table thead th:nth-child(3) {
  color: #36A1F5 !important;
}
.resultModal .resultsortingtable.chapter_wisetable .table thead th:nth-child(4) {
  color: #00C596 !important;
}
.resultModal .resultsortingtable.chapter_wisetable .table thead th:nth-child(5) {
  color: #F05D70 !important;
}
.resultModal .resultsortingtable.chapter_wisetable .table thead th:nth-child(6) {
  color: #DF7E00 !important;
}
.resultModal .questionTypetable .react-bootstrap-table .table thead {
  background: #ffffff !important;
}
@media (max-width: 991px) {
  .resultModal .card-group {
    display: flex;
    flex-flow: column wrap !important;
  }
  .resultModal .card-group > .card:first-child {
    padding: 0.5rem;
  }
  .resultModal .card-group > .card {
    margin-bottom: 15px;
    border: none;
  }
}

.practice_exams_area {
  position: relative;
}
@media (max-width: 767px) {
  .practice_exams_area .navbar-brand svg {
    width: 100px;
  }
}
.practice_exams_area .score-card {
  border-radius: 8px;
}
@media (max-width: 767px) {
  .practice_exams_area .score-card .card-title {
    font-size: 2.35rem;
  }
}
.practice_exams_area .score-card .dot-circle li {
  width: 4%;
  line-height: 16px !important;
}
.practice_exams_area .score-card .dot-circle li i {
  font-size: 10px;
}
.practice_exams_area .score-card small {
  font-size: 14px;
}
.practice_exams_area .avgtime-card {
  border-radius: 8px;
}
.practice_exams_area .avgtime-card .dot-circle li {
  width: 4%;
  line-height: 16px !important;
}
.practice_exams_area .avgtime-card .dot-circle li i {
  font-size: 10px;
}
.practice_exams_area .avgtime-card small {
  font-size: 14px;
}
.practice_exams_area .subject_cards {
  border-radius: 8px;
}
.practice_exams_area .subject_cards .row [class*=col]:not(:last-child) {
  padding-right: 0.4rem !important;
}
@media (max-width: 767px) and (max-width: 575px) {
  .practice_exams_area .subject_cards .row [class*=col]:not(:last-child) {
    padding-right: 0px;
  }
}
@media (max-width: 991px) {
  .practice_exams_area .subject_cards .col {
    flex: 0 0 50%;
    max-width: 50%;
    padding: 10px;
  }
}
@media (max-width: 767px) {
  .practice_exams_area .subject_cards .col {
    flex: 0 0 50%;
    max-width: 50%;
    padding: 10px;
  }
}
@media (max-width: 575px) {
  .practice_exams_area .subject_cards .col {
    flex: 0 0 50%;
    max-width: 50%;
    padding: 10px;
  }
}
.practice_exams_area .subject_cards .card {
  overflow: hidden;
  border-radius: 8px;
}
.practice_exams_area .subject_cards .card .card-header .icon svg {
  width: 35px;
  height: 35px;
}
.practice_exams_area .subject_cards .card .card-body {
  border-radius: 8px;
  color: #ffffff;
}
.practice_exams_area .subject_cards .card .card-body small {
  font-size: 14px;
}
.practice_exams_area .subject_cards .card.physics {
  border-color: #F05D70;
}
.practice_exams_area .subject_cards .card.physics .card-body {
  background: #F05D70;
}
.practice_exams_area .subject_cards .card.chemistry {
  border-color: #0060CE;
}
.practice_exams_area .subject_cards .card.chemistry .card-body {
  background: #0060CE;
}
.practice_exams_area .subject_cards .card.botany {
  border-color: #3AC555;
}
.practice_exams_area .subject_cards .card.botany .card-body {
  background: #3AC555;
}
.practice_exams_area .subject_cards .card.zoology {
  border-color: #C37800;
}
.practice_exams_area .subject_cards .card.zoology .card-body {
  background: #C37800;
}
.practice_exams_area .subject_cards .card.maths {
  border-color: #707070;
}
.practice_exams_area .subject_cards .card.maths .card-body {
  background: #707070;
}
.practice_exams_area .maintable .table th,
.practice_exams_area .maintable .table td {
  padding: 8px 18px;
}
.practice_exams_area .maintable .table tr th:not(:last-child),
.practice_exams_area .maintable .table tr td:not(:last-child) {
  border-right: 1px solid #dee2e6;
}
.practice_exams_area .maintable .table thead tr th {
  border-top: none;
}
.practice_exams_area .maintable .table tbody tr td {
  font-weight: 700;
  text-align: center;
}
.practice_exams_area .maintable .table tbody tr td:nth-child(2) {
  background: #f8fffa;
}
.practice_exams_area .maintable .table tbody tr td:nth-child(3) {
  background: #fffcf6;
}
.practice_exams_area .maintable .table tbody tr td:nth-child(4) {
  background: #fff9fa;
}
.practice_exams_area .maintable .table tbody tr td:nth-child(5) {
  background: #fff8f8;
}
.practice_exams_area .maintable .table tbody tr:nth-child(2) td:nth-child(2) {
  background: #eafff0;
}
.practice_exams_area .maintable .table tbody tr:nth-child(2) td:nth-child(3) {
  background: #fff9e9;
}
.practice_exams_area .maintable .table tbody tr:nth-child(2) td:nth-child(4) {
  background: #fdf0f2;
}
.practice_exams_area .maintable .table tbody tr:nth-child(2) td:nth-child(5) {
  background: #ffe5e5;
}
.practice_exams_area .maintable .table tbody tr:nth-child(3) td:nth-child(2) {
  background: #dffbe7;
}
.practice_exams_area .maintable .table tbody tr:nth-child(3) td:nth-child(3) {
  background: #fff6da;
}
.practice_exams_area .maintable .table tbody tr:nth-child(3) td:nth-child(4) {
  background: #fce7ea;
}
.practice_exams_area .maintable .table tbody tr:nth-child(3) td:nth-child(5) {
  background: #ffdada;
}
.practice_exams_area .maintable .table tbody tr:nth-child(4) td:nth-child(2) {
  background: #d0ffde;
}
.practice_exams_area .maintable .table tbody tr:nth-child(4) td:nth-child(3) {
  background: #fff1ca;
}
.practice_exams_area .maintable .table tbody tr:nth-child(4) td:nth-child(4) {
  background: #fbdce0;
}
.practice_exams_area .maintable .table tbody tr:nth-child(4) td:nth-child(5) {
  background: #ffc7c7;
}
.practice_exams_area .totalgrand-table .table tr th,
.practice_exams_area .totalgrand-table .table tr td {
  padding: 8px 18px;
  border-top: none;
  font-weight: 700;
}
.practice_exams_area .totalgrand-table .table tr th .icon svg,
.practice_exams_area .totalgrand-table .table tr td .icon svg {
  width: 15px;
  height: 15px;
}
.practice_exams_area .totalgrand-table .table tr th:not(:last-child),
.practice_exams_area .totalgrand-table .table tr td:not(:last-child) {
  border-right: 1px solid #dee2e6;
}
.practice_exams_area .totalgrand-table .table thead tr th {
  font-weight: 400;
  border-top: none;
}
.practice_exams_area .totalgrand-table .table tbody tr:nth-child(1) {
  background-color: #f8f1de;
}
.practice_exams_area .accurancy-table .table tr th,
.practice_exams_area .accurancy-table .table tr td {
  padding: 8px 18px;
}
.practice_exams_area .accurancy-table .table tr th .icon svg,
.practice_exams_area .accurancy-table .table tr td .icon svg {
  width: 25px;
  height: 25px;
}
.practice_exams_area .accurancy-table .table tr td {
  text-align: center;
}
.practice_exams_area .accurancy-table .table tr th:not(:last-child),
.practice_exams_area .accurancy-table .table tr td:not(:last-child) {
  border-right: 1px solid #dee2e6;
}
.practice_exams_area .accurancy-table .table thead tr th {
  text-align: center;
  font-weight: 700;
  border-top: none;
}
.practice_exams_area .accurancy-table .table tbody tr td:first-child {
  font-weight: 700;
}
.practice_exams_area .accurancy-table .table tbody tr:nth-child(1) {
  background-color: #f8f1de;
}
.practice_exams_area .accurancy-table .table tbody tr:nth-child(8) {
  background-color: #F4F4F4;
}
.practice_exams_area .accurancy-table .table tbody tr:nth-child(9) {
  background-color: #F4F4F4;
}
.practice_exams_area .accurancy-table .table tbody tr:nth-child(10) {
  background-color: #F4F4F4;
}
.practice_exams_area .examquestion-table .table tr th,
.practice_exams_area .examquestion-table .table tr td {
  padding: 6px 10px;
}
.practice_exams_area .examquestion-table .table tr th:not(:last-child),
.practice_exams_area .examquestion-table .table tr td:not(:last-child) {
  border-right: 1px solid #dee2e6;
}
.practice_exams_area .examquestion-table .table thead tr th {
  font-weight: 600;
  border-top: none;
  font-size: 12px;
}
.practice_exams_area .examquestion-table .table thead tr th:nth-child(1) {
  text-align: left;
}
.practice_exams_area .examquestion-table .table tbody tr td {
  font-size: 12px;
  text-align: center;
}
.practice_exams_area .examquestion-table .table tbody tr td:nth-child(1) {
  text-align: left;
  font-weight: 600;
}
.practice_exams_area .errorreport-table .card-header {
  background: #e1f2ff;
}
.practice_exams_area .errorreport-table .card-header .card-title {
  transform: matrix(0, -1, 1, 0, -50, 70);
  position: absolute;
  left: 0;
}
.practice_exams_area .errorreport-table .table tr th,
.practice_exams_area .errorreport-table .table tr td {
  padding: 8px 18px;
  border-top: none;
}
.practice_exams_area .errorreport-table .table tr th .icon svg,
.practice_exams_area .errorreport-table .table tr td .icon svg {
  width: 20px;
  height: 20px;
}
.practice_exams_area .errorreport-table .table tr th:not(:last-child),
.practice_exams_area .errorreport-table .table tr td:not(:last-child) {
  border-right: 1px solid #dee2e6;
}
.practice_exams_area .errorreport-table .table thead tr th {
  font-weight: 600;
  border: none;
}
.practice_exams_area .observation-card {
  position: relative;
}
.practice_exams_area .observation-card .card-header {
  background: #f7aeb7;
}
.practice_exams_area .observation-card .card-header .card-title {
  transform: matrix(0, -1, 1, 0, -45, 70);
  position: absolute;
  left: 0;
}
.practice_exams_area .observation-card .card-body .observation-list li {
  position: relative;
  padding-left: 40px;
}
.practice_exams_area .observation-card .card-body .observation-list li::before {
  content: "";
  position: absolute;
  left: 20px;
  top: 8px;
  width: 8px;
  height: 8px;
  background: #F05D70;
  border-radius: 50%;
}
.practice_exams_area .questiontypeanalysis-table .table tr th,
.practice_exams_area .questiontypeanalysis-table .table tr td,
.practice_exams_area .questiontheory-table .table tr th,
.practice_exams_area .questiontheory-table .table tr td {
  padding: 8px 16px;
  border-top: none;
}
.practice_exams_area .questiontypeanalysis-table .table tr td,
.practice_exams_area .questiontheory-table .table tr td {
  text-align: center;
}
.practice_exams_area .questiontypeanalysis-table .table tr th:not(:last-child),
.practice_exams_area .questiontypeanalysis-table .table tr td:not(:last-child),
.practice_exams_area .questiontheory-table .table tr th:not(:last-child),
.practice_exams_area .questiontheory-table .table tr td:not(:last-child) {
  border-right: 1px solid #dee2e6;
}
.practice_exams_area .questiontypeanalysis-table .table thead tr th,
.practice_exams_area .questiontheory-table .table thead tr th {
  text-align: center;
  font-weight: 600;
}
.practice_exams_area .act-table .table tr th,
.practice_exams_area .act-table .table tr td {
  padding: 8px;
  border: none;
}
.practice_exams_area .act-table .table tr th h6 {
  margin-bottom: 0.2rem;
  font-size: 0.9rem;
}
.practice_exams_area .act-table .table tr th p {
  font-size: 9px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.practice_exams_area .act-table .correct-table {
  background: transparent linear-gradient(-90deg, #FFFFFF 0%, rgba(25, 203, 161, 0.3960784314) 100%) 0% 0% no-repeat;
}
.practice_exams_area .act-table .correct-table .card {
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1607843137);
  border-radius: 6px;
}
.practice_exams_area .act-table .correct-table .card:not(:last-child) {
  margin-right: 0.3rem;
}
.practice_exams_area .act-table .wrong-table {
  background: transparent linear-gradient(-90deg, #FFFFFF 0%, rgba(240, 93, 113, 0.4392156863) 100%) 0% 0% no-repeat;
}
.practice_exams_area .act-table .wrong-table .card {
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1607843137);
  border-radius: 6px;
}
.practice_exams_area .act-table .wrong-table .card:not(:last-child) {
  margin-right: 0.3rem;
}
@media (min-width: 768px) {
  .practice_exams_area .chapterwise-table .subjects-selection-filter {
    width: 25%;
  }
}
@media (max-width: 767px) {
  .practice_exams_area .chapterwise-table .subjects-selection-filter {
    width: 100%;
    margin-left: 0 !important;
    margin-top: 0.65rem;
  }
}
.practice_exams_area .chapterwise-table .table-fixed thead {
  width: 98.5%;
}
.practice_exams_area .chapterwise-table .table-fixed tbody {
  height: 250px;
  overflow-y: auto;
  width: 100%;
}
@media (min-width: 992px) {
  .practice_exams_area .chapterwise-table .table-fixed thead,
  .practice_exams_area .chapterwise-table .table-fixed tbody,
  .practice_exams_area .chapterwise-table .table-fixed tr,
  .practice_exams_area .chapterwise-table .table-fixed td,
  .practice_exams_area .chapterwise-table .table-fixed th {
    display: flow-root;
  }
}
@media (min-width: 992px) {
  .practice_exams_area .chapterwise-table .table-fixed tbody td,
  .practice_exams_area .chapterwise-table .table-fixed thead > tr > th {
    float: left;
    border-bottom-width: 0;
  }
}
.practice_exams_area .chapterwise-table .table tr th,
.practice_exams_area .chapterwise-table .table tr td {
  padding: 8px 18px;
  border-top: none;
  text-align: left;
}
.practice_exams_area .chapterwise-table .table tr td:nth-child(1) {
  text-align: left;
}
.practice_exams_area .chapterwise-table .table tr th:not(:last-child),
.practice_exams_area .chapterwise-table .table tr td:not(:last-child) {
  border-right: 1px solid #dee2e6;
}
.practice_exams_area .chapterwise-table .table thead tr th {
  font-weight: 600;
  border-bottom: 1px solid #dee2e6;
}
.practice_exams_area .chapterwise-table .table tbody tr td:nth-child(1) {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.practice_exams_area .chapterwise-table .table tbody tr td:nth-child(2) {
  color: var(--red);
}
.practice_exams_area .chapterwise-table .table tbody tr td:nth-child(3) {
  color: var(--info);
}
.practice_exams_area .chapterwise-table .table tbody tr td:nth-child(4) {
  color: var(--green);
}
.practice_exams_area .chapterwise-table .table tbody tr td:nth-child(5) {
  color: var(--pink);
}
.practice_exams_area .chapterwise-table .table tbody tr td:nth-child(6) {
  color: var(--purple);
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/exams/_resultmodel.scss"],"names":[],"mappings":"AACI;EACI,wBAAA;AAAR;AAGI;EACI,kBAAA;EACA,kBAAA;AADR;AAGQ;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AADZ;AAMQ;EACI,mBAAA;AAJZ;AASQ;EAEI,mBAAA;AARZ;AAYI;EACI,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAVR;AAYQ;EACI,qBAAA;AAVZ;AAaY;EACI,iBAAA;AAXhB;AAcY;EACI,eAAA;AAZhB;AAeY;EACI,kBAAA;EACA,cAAA;EACA,2BAAA;EACA,uBAAA;AAbhB;AAegB;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;AAbpB;AA4BI;;EAEI,gBAAA;AA1BR;AA4BQ;;;;EAEI,iBAAA;AAxBZ;AA2BQ;;EACI,sBAAA;EACA,gCAAA;AAxBZ;AA2BQ;;EACI,2BAAA;AAxBZ;AA6BI;;;;EAII,kDAAA;AA3BR;AA8BI;EACI,yBAAA;EACA,4BAAA;AA5BR;AA8BQ;EACI,yBAAA;EACA,yBAAA;AA5BZ;AAoCY;;EAEI,kDAAA;AAlChB;AAqCY;EACI,8BAAA;AAnChB;AAqCgB;EACI,yBAAA;AAnCpB;AAsCgB;EACI,yBAAA;AApCpB;AAuCgB;EACI,yBAAA;AArCpB;AA0CgB;EACI,cAAA;EACA,2BAAA;AAxCpB;AA0CoB;EACI,2BAAA;AAxCxB;AAiDQ;;EAEI,kDAAA;AA/CZ;AAmDY;EACI,cAAA;EACA,2BAAA;AAjDhB;AAmDgB;EACI,2BAAA;AAjDpB;AA0DY;;EAEI,yBAAA;EAIA,mDAAA;AA3DhB;AA6DgB;;EACI,kBAAA;AA1DpB;AA8DY;EACI,8BAAA;AA5DhB;AA8DgB;EACI,yBAAA;AA5DpB;AA+DgB;EACI,yBAAA;AA7DpB;AAgEgB;EACI,yBAAA;AA9DpB;AAiEgB;EACI,yBAAA;AA/DpB;AAuEgB;;EAKI,mDAAA;AAxEpB;AA0EoB;;EACI,kBAAA;AAvExB;AA2EgB;EACI,8BAAA;AAzEpB;AA2EoB;EACI,yBAAA;AAzExB;AA4EoB;EACI,yBAAA;AA1ExB;AA6EoB;EACI,yBAAA;AA3ExB;AA8EoB;EACI,yBAAA;AA5ExB;AA+EoB;EACI,yBAAA;AA7ExB;AAqFQ;EACI,8BAAA;AAnFZ;AAuFI;EACI;IACI,aAAA;IACA,iCAAA;EArFV;EAyFM;IACI,eAAA;EAvFV;EA0FM;IACI,mBAAA;IACA,YAAA;EAxFV;AACF;;AA8FA;EACI,kBAAA;AA3FJ;AA6FI;EACI;IACI,YAAA;EA3FV;AACF;AA8FI;EACI,kBAAA;AA5FR;AA+FY;EADJ;IAEQ,kBAAA;EA5Fd;AACF;AAgGY;EACI,SAAA;EACA,4BAAA;AA9FhB;AAgGgB;EACI,eAAA;AA9FpB;AAmGQ;EACI,eAAA;AAjGZ;AAqGI;EACI,kBAAA;AAnGR;AAuGY;EACI,SAAA;EACA,4BAAA;AArGhB;AAuGgB;EACI,eAAA;AArGpB;AA0GQ;EACI,eAAA;AAxGZ;AA4GI;EACI,kBAAA;AA1GR;AA4GQ;EACI,gCAAA;AA1GZ;AA4GY;EAHJ;IAIQ,kBAAA;EAzGd;AACF;AA6GY;EADJ;IAEQ,aAAA;IACA,cAAA;IACA,aAAA;EA1Gd;AACF;AA4GY;EAPJ;IAQQ,aAAA;IACA,cAAA;IACA,aAAA;EAzGd;AACF;AA2GY;EAbJ;IAcQ,aAAA;IACA,cAAA;IACA,aAAA;EAxGd;AACF;AA2GQ;EACI,gBAAA;EACA,kBAAA;AAzGZ;AA4GgB;EACI,WAAA;EACA,YAAA;AA1GpB;AA8GY;EACI,kBAAA;EACA,cAAA;AA5GhB;AA8GgB;EACI,eAAA;AA5GpB;AAgHY;EACI,qBAAA;AA9GhB;AAgHgB;EACI,mBAAA;AA9GpB;AAkHY;EACI,qBAAA;AAhHhB;AAkHgB;EACI,mBAAA;AAhHpB;AAoHY;EACI,qBAAA;AAlHhB;AAoHgB;EACI,mBAAA;AAlHpB;AAsHY;EACI,qBAAA;AApHhB;AAsHgB;EACI,mBAAA;AApHpB;AAwHY;EACI,qBAAA;AAtHhB;AAwHgB;EACI,mBAAA;AAtHpB;AAkIY;;EAEI,iBAAA;AAhIhB;AAmIY;;EAEI,+BAAA;AAjIhB;AAoIY;EACI,gBAAA;AAlIhB;AAuIoB;EACI,gBAAA;EACA,kBAAA;AArIxB;AAuIwB;EACI,mBAAA;AArI5B;AAwIwB;EACI,mBAAA;AAtI5B;AAyIwB;EACI,mBAAA;AAvI5B;AA0IwB;EACI,mBAAA;AAxI5B;AA6IwB;EACI,mBAAA;AA3I5B;AA8IwB;EACI,mBAAA;AA5I5B;AA+IwB;EACI,mBAAA;AA7I5B;AAgJwB;EACI,mBAAA;AA9I5B;AAmJwB;EACI,mBAAA;AAjJ5B;AAoJwB;EACI,mBAAA;AAlJ5B;AAqJwB;EACI,mBAAA;AAnJ5B;AAsJwB;EACI,mBAAA;AApJ5B;AAyJwB;EACI,mBAAA;AAvJ5B;AA0JwB;EACI,mBAAA;AAxJ5B;AA2JwB;EACI,mBAAA;AAzJ5B;AA4JwB;EACI,mBAAA;AA1J5B;AAqKY;;EAEI,iBAAA;EACA,gBAAA;EACA,gBAAA;AAnKhB;AAqKgB;;EACI,WAAA;EACA,YAAA;AAlKpB;AAsKY;;EAEI,+BAAA;AApKhB;AAuKY;EACI,gBAAA;EACA,gBAAA;AArKhB;AAwKY;EACI,yBAAA;AAtKhB;AA8KY;;EAEI,iBAAA;AA5KhB;AA8KgB;;EACI,WAAA;EACA,YAAA;AA3KpB;AAgLY;EACI,kBAAA;AA9KhB;AAiLY;;EAEI,+BAAA;AA/KhB;AAkLY;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;AAhLhB;AAoLgB;EACI,gBAAA;AAlLpB;AAqLgB;EACI,yBAAA;AAnLpB;AAsLgB;EACI,yBAAA;AApLpB;AAuLgB;EACI,yBAAA;AArLpB;AAwLgB;EACI,yBAAA;AAtLpB;AA+LY;;EAEI,iBAAA;AA7LhB;AAgMY;;EAEI,+BAAA;AA9LhB;AAiMY;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;AA/LhB;AAiMgB;EACI,gBAAA;AA/LpB;AAmMY;EACI,eAAA;EACA,kBAAA;AAjMhB;AAmMgB;EACI,gBAAA;EACA,gBAAA;AAjMpB;AAwMQ;EACI,mBAAA;AAtMZ;AAwMY;EACI,uCAAA;EACA,kBAAA;EACA,OAAA;AAtMhB;AA6MY;;EAEI,iBAAA;EACA,gBAAA;AA3MhB;AA6MgB;;EACI,WAAA;EACA,YAAA;AA1MpB;AA8MY;;EAEI,+BAAA;AA5MhB;AA+MY;EACI,gBAAA;EACA,YAAA;AA7MhB;AAkNI;EACI,kBAAA;AAhNR;AAkNQ;EACI,mBAAA;AAhNZ;AAkNY;EACI,uCAAA;EACA,kBAAA;EACA,OAAA;AAhNhB;AAqNY;EACI,kBAAA;EACA,kBAAA;AAnNhB;AAqNgB;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAnNpB;AA6NY;;;;EAEI,iBAAA;EACA,gBAAA;AAzNhB;AA4NY;;EACI,kBAAA;AAzNhB;AA4NY;;;;EAEI,+BAAA;AAxNhB;AA2NY;;EACI,kBAAA;EACA,gBAAA;AAxNhB;AAgOY;;EAEI,YAAA;EACA,YAAA;AA9NhB;AAkOgB;EACI,qBAAA;EACA,iBAAA;AAhOpB;AAmOgB;EACI,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjOpB;AAuOQ;EACI,kHAAA;AArOZ;AAuOY;EACI,oDAAA;EACA,kBAAA;AArOhB;AAuOgB;EACI,oBAAA;AArOpB;AA0OQ;EACI,kHAAA;AAxOZ;AA0OY;EACI,oDAAA;EACA,kBAAA;AAxOhB;AA0OgB;EACI,oBAAA;AAxOpB;AAgPY;EADJ;IAEQ,UAAA;EA7Od;AACF;AA+OY;EALJ;IAMQ,WAAA;IACA,yBAAA;IACA,mBAAA;EA5Od;AACF;AA+OQ;EACI,YAAA;AA7OZ;AAgPQ;EACI,aAAA;EACA,gBAAA;EACA,WAAA;AA9OZ;AAiPQ;EAEI;;;;;IAKI,kBAAA;EAhPd;AACF;AAmPQ;EAEI;;IAEI,WAAA;IACA,sBAAA;EAlPd;AACF;AAuPY;;EAEI,iBAAA;EACA,gBAAA;EACA,gBAAA;AArPhB;AAwPY;EACI,gBAAA;AAtPhB;AAyPY;;EAEI,+BAAA;AAvPhB;AA2PgB;EACI,gBAAA;EACA,gCAAA;AAzPpB;AAgQoB;EACI,mBAAA;EACA,uBAAA;EACA,gBAAA;AA9PxB;AAiQoB;EACI,iBAAA;AA/PxB;AAkQoB;EACI,kBAAA;AAhQxB;AAmQoB;EACI,mBAAA;AAjQxB;AAoQoB;EACI,kBAAA;AAlQxB;AAqQoB;EACI,oBAAA;AAnQxB","sourcesContent":[".resultModal {\n    .speedometer .current-value {\n        fill: #333333 !important;\n    }\n\n    .observation-list .list-unstyled li {\n        position: relative;\n        padding-left: 15px;\n\n        &::before {\n            content: '';\n            position: absolute;\n            left: 0;\n            top: 8px;\n            width: 8px;\n            height: 8px;\n            border-radius: 50%;\n        }\n    }\n\n    .observation-list .list-unstyled.one-list li {\n        &::before {\n            background: #F05D70;\n        }\n    }\n\n    .observation-list .list-unstyled.two-list li {\n        &::before {\n            // background: #00C596;\n            background: #ff471a;\n        }\n    }\n\n    .nav-pills {\n        border: 1px solid #212B65;\n        border-radius: 30px;\n        margin: 0;\n        padding: 3px;\n\n        .nav-item {\n            display: inline-block;\n            // width: 50%;\n\n            & {\n                margin-right: 2px;\n            }\n\n            &:last-child {\n                margin-right: 0;\n            }\n\n            .nav-link {\n                text-align: center;\n                color: #212B65;\n                transition: all .2s linear;\n                padding: 0.35rem 0.5rem;\n\n                &.active {\n                    color: #ffffff;\n                    font-weight: 600;\n                    border-radius: 30px;\n                    background-color: #212B65 !important;\n                }\n            }\n        }\n    }\n\n    // .status-resport {\n    //     .rank-card {\n    //         color: #ffffff;\n    //         background: #00C596;\n    //         border: 1px solid #00C596;\n    //         border-radius: 5px;\n    //     }\n    // }\n\n    .examWise,\n    .chapterWise {\n        margin-bottom: 0;\n\n        th,\n        td {\n            padding: 6px 12px;\n        }\n\n        thead th {\n            vertical-align: middle;\n            border-bottom: 1px solid #dee2e6;\n        }\n\n        tbody td+td {\n            font-weight: 600 !important;\n        }\n\n    }\n\n    table.examWise th+th,\n    table.examWise td+td,\n    table.chapterWise th+th,\n    table.chapterWise td+td {\n        border-left: 1px solid #00000020;\n    }\n\n    .errorTitle {\n        background-color: #E1F2FF;\n        padding-top: 15px !important;\n\n        .errorText {\n            writing-mode: vertical-rl;\n            transform: rotate(179deg);\n\n        }\n    }\n\n    .correctComplexitytable {\n        .react-bootstrap-table .table {\n\n            th+th,\n            td+td {\n                border-left: 1px solid #00000020;\n            }\n\n            thead {\n                background: #ffffff !important;\n\n                th:nth-child(2) {\n                    color: #28a745 !important;\n                }\n\n                th:nth-child(3) {\n                    color: #dc3545 !important;\n                }\n\n                th:nth-child(4) {\n                    color: #ffc107 !important;\n                }\n            }\n\n            tbody {\n                td {\n                    color: #142031;\n                    font-weight: 600 !important;\n\n                    &:first-child {\n                        font-weight: 400 !important;\n                    }\n                }\n            }\n        }\n    }\n\n    .questionTypetable .react-bootstrap-table .table {\n\n        th+th,\n        td+td {\n            border-left: 1px solid #00000020;\n        }\n\n        tbody {\n            td {\n                color: #142031;\n                font-weight: 600 !important;\n\n                &:first-child {\n                    font-weight: 400 !important;\n                }\n            }\n        }\n    }\n\n    .resultsortingtable {\n        .table {\n\n            td,\n            th {\n                color: #142031 !important;\n                // padding: 4px;\n                // padding: 0.65rem;\n                // font-size: 13px !important;\n                border-right: 1px solid #00000020;\n\n                &:last-child {\n                    border-right: none;\n                }\n            }\n\n            thead {\n                background: #ffffff !important;\n\n                th:nth-child(2) {\n                    color: #36A1F5 !important;\n                }\n\n                th:nth-child(3) {\n                    color: #00C596 !important;\n                }\n\n                th:nth-child(4) {\n                    color: #F05D70 !important;\n                }\n\n                th:nth-child(5) {\n                    color: #DF7E00 !important;\n                }\n            }\n        }\n\n        &.chapter_wisetable {\n            .table {\n\n                td,\n                th {\n                    // padding: 4px;\n                    // padding: 0.65rem;\n                    // font-size: 13px !important;\n                    border-right: 1px solid #00000020;\n\n                    &:last-child {\n                        border-right: none;\n                    }\n                }\n\n                thead {\n                    background: #ffffff !important;\n\n                    th:nth-child(2) {\n                        color: #ac072b !important;\n                    }\n\n                    th:nth-child(3) {\n                        color: #36A1F5 !important;\n                    }\n\n                    th:nth-child(4) {\n                        color: #00C596 !important;\n                    }\n\n                    th:nth-child(5) {\n                        color: #F05D70 !important;\n                    }\n\n                    th:nth-child(6) {\n                        color: #DF7E00 !important;\n                    }\n                }\n            }\n        }\n    }\n\n    .questionTypetable {\n        .react-bootstrap-table .table thead {\n            background: #ffffff !important;\n        }\n    }\n\n    @media (max-width: 991px) {\n        .card-group {\n            display: flex;\n            flex-flow: column wrap !important;\n\n        }\n\n        .card-group>.card:first-child {\n            padding: .5rem;\n        }\n\n        .card-group>.card {\n            margin-bottom: 15px;\n            border: none;\n        }\n    }\n}\n\n// Practice Test Exams CSS\n\n.practice_exams_area {\n    position: relative;\n\n    @media (max-width: 767px) {\n        .navbar-brand svg {\n            width: 100px;\n        }\n    }\n\n    .score-card {\n        border-radius: 8px;\n\n        .card-title {\n            @media (max-width: 767px) {\n                font-size: 2.35rem;\n            }\n        }\n\n        .dot-circle {\n            li {\n                width: 4%;\n                line-height: 16px !important;\n\n                i {\n                    font-size: 10px;\n                }\n            }\n        }\n\n        small {\n            font-size: 14px;\n        }\n    }\n\n    .avgtime-card {\n        border-radius: 8px;\n\n        .dot-circle {\n\n            li {\n                width: 4%;\n                line-height: 16px !important;\n\n                i {\n                    font-size: 10px;\n                }\n            }\n        }\n\n        small {\n            font-size: 14px;\n        }\n    }\n\n    .subject_cards {\n        border-radius: 8px;\n\n        .row [class*=\"col\"]:not(:last-child) {\n            padding-right: 0.4rem !important;\n\n            @media (max-width: 767px) and (max-width: 575px) {\n                padding-right: 0px;\n            }\n        }\n\n        .col {\n            @media (max-width: 991px) {\n                flex: 0 0 50%;\n                max-width: 50%;\n                padding: 10px;\n            }\n\n            @media (max-width: 767px) {\n                flex: 0 0 50%;\n                max-width: 50%;\n                padding: 10px;\n            }\n\n            @media (max-width: 575px) {\n                flex: 0 0 50%;\n                max-width: 50%;\n                padding: 10px;\n            }\n        }\n\n        .card {\n            overflow: hidden;\n            border-radius: 8px;\n\n            .card-header {\n                .icon svg {\n                    width: 35px;\n                    height: 35px;\n                }\n            }\n\n            .card-body {\n                border-radius: 8px;\n                color: #ffffff;\n\n                small {\n                    font-size: 14px;\n                }\n            }\n\n            &.physics {\n                border-color: #F05D70;\n\n                .card-body {\n                    background: #F05D70;\n                }\n            }\n\n            &.chemistry {\n                border-color: #0060CE;\n\n                .card-body {\n                    background: #0060CE;\n                }\n            }\n\n            &.botany {\n                border-color: #3AC555;\n\n                .card-body {\n                    background: #3AC555;\n                }\n            }\n\n            &.zoology {\n                border-color: #C37800;\n\n                .card-body {\n                    background: #C37800;\n                }\n            }\n\n            &.maths {\n                border-color: #707070;\n\n                .card-body {\n                    background: #707070;\n                }\n            }\n\n        }\n\n    }\n\n    .maintable {\n\n        .table {\n\n            th,\n            td {\n                padding: 8px 18px;\n            }\n\n            tr th:not(:last-child),\n            tr td:not(:last-child) {\n                border-right: 1px solid #dee2e6;\n            }\n\n            thead tr th {\n                border-top: none;\n            }\n\n            tbody {\n                tr {\n                    td {\n                        font-weight: 700;\n                        text-align: center;\n\n                        &:nth-child(2) {\n                            background: #f8fffa;\n                        }\n\n                        &:nth-child(3) {\n                            background: #fffcf6;\n                        }\n\n                        &:nth-child(4) {\n                            background: #fff9fa;\n                        }\n\n                        &:nth-child(5) {\n                            background: #fff8f8;\n                        }\n                    }\n\n                    &:nth-child(2) {\n                        td:nth-child(2) {\n                            background: #eafff0;\n                        }\n\n                        td:nth-child(3) {\n                            background: #fff9e9;\n                        }\n\n                        td:nth-child(4) {\n                            background: #fdf0f2;\n                        }\n\n                        td:nth-child(5) {\n                            background: #ffe5e5;\n                        }\n                    }\n\n                    &:nth-child(3) {\n                        td:nth-child(2) {\n                            background: #dffbe7;\n                        }\n\n                        td:nth-child(3) {\n                            background: #fff6da;\n                        }\n\n                        td:nth-child(4) {\n                            background: #fce7ea;\n                        }\n\n                        td:nth-child(5) {\n                            background: #ffdada;\n                        }\n                    }\n\n                    &:nth-child(4) {\n                        td:nth-child(2) {\n                            background: #d0ffde;\n                        }\n\n                        td:nth-child(3) {\n                            background: #fff1ca;\n                        }\n\n                        td:nth-child(4) {\n                            background: #fbdce0;\n                        }\n\n                        td:nth-child(5) {\n                            background: #ffc7c7;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .totalgrand-table {\n        .table {\n\n            tr th,\n            tr td {\n                padding: 8px 18px;\n                border-top: none;\n                font-weight: 700;\n\n                .icon svg {\n                    width: 15px;\n                    height: 15px;\n                }\n            }\n\n            tr th:not(:last-child),\n            tr td:not(:last-child) {\n                border-right: 1px solid #dee2e6;\n            }\n\n            thead tr th {\n                font-weight: 400;\n                border-top: none;\n            }\n\n            tbody tr:nth-child(1) {\n                background-color: #f8f1de;\n            }\n        }\n    }\n\n    .accurancy-table {\n        .table {\n\n            tr th,\n            tr td {\n                padding: 8px 18px;\n\n                .icon svg {\n                    width: 25px;\n                    height: 25px;\n                }\n\n            }\n\n            tr td {\n                text-align: center;\n            }\n\n            tr th:not(:last-child),\n            tr td:not(:last-child) {\n                border-right: 1px solid #dee2e6;\n            }\n\n            thead tr th {\n                text-align: center;\n                font-weight: 700;\n                border-top: none;\n            }\n\n            tbody tr {\n                td:first-child {\n                    font-weight: 700;\n                }\n\n                &:nth-child(1) {\n                    background-color: #f8f1de;\n                }\n\n                &:nth-child(8) {\n                    background-color: #F4F4F4;\n                }\n\n                &:nth-child(9) {\n                    background-color: #F4F4F4;\n                }\n\n                &:nth-child(10) {\n                    background-color: #F4F4F4;\n                }\n            }\n        }\n    }\n\n    .examquestion-table {\n        .table {\n\n            tr th,\n            tr td {\n                padding: 6px 10px;\n            }\n\n            tr th:not(:last-child),\n            tr td:not(:last-child) {\n                border-right: 1px solid #dee2e6;\n            }\n\n            thead tr th {\n                font-weight: 600;\n                border-top: none;\n                font-size: 12px;\n\n                &:nth-child(1) {\n                    text-align: left;\n                }\n            }\n\n            tbody tr td {\n                font-size: 12px;\n                text-align: center;\n\n                &:nth-child(1) {\n                    text-align: left;\n                    font-weight: 600;\n                }\n            }\n        }\n    }\n\n    .errorreport-table {\n        .card-header {\n            background: #e1f2ff;\n\n            .card-title {\n                transform: matrix(0, -1, 1, 0, -50, 70);\n                position: absolute;\n                left: 0;\n            }\n        }\n\n\n        .table {\n\n            tr th,\n            tr td {\n                padding: 8px 18px;\n                border-top: none;\n\n                .icon svg {\n                    width: 20px;\n                    height: 20px;\n                }\n            }\n\n            tr th:not(:last-child),\n            tr td:not(:last-child) {\n                border-right: 1px solid #dee2e6;\n            }\n\n            thead tr th {\n                font-weight: 600;\n                border: none;\n            }\n        }\n    }\n\n    .observation-card {\n        position: relative;\n\n        .card-header {\n            background: #f7aeb7;\n\n            .card-title {\n                transform: matrix(0, -1, 1, 0, -45, 70);\n                position: absolute;\n                left: 0;\n            }\n        }\n\n        .card-body {\n            .observation-list li {\n                position: relative;\n                padding-left: 40px;\n\n                &::before {\n                    content: '';\n                    position: absolute;\n                    left: 20px;\n                    top: 8px;\n                    width: 8px;\n                    height: 8px;\n                    background: #F05D70;\n                    border-radius: 50%;\n                }\n            }\n        }\n    }\n\n    .questiontypeanalysis-table,\n    .questiontheory-table {\n        .table {\n\n            tr th,\n            tr td {\n                padding: 8px 16px;\n                border-top: none;\n            }\n\n            tr td {\n                text-align: center;\n            }\n\n            tr th:not(:last-child),\n            tr td:not(:last-child) {\n                border-right: 1px solid #dee2e6;\n            }\n\n            thead tr th {\n                text-align: center;\n                font-weight: 600;\n            }\n        }\n    }\n\n    .act-table {\n        .table {\n\n            tr th,\n            tr td {\n                padding: 8px;\n                border: none;\n            }\n\n            tr th {\n                h6 {\n                    margin-bottom: 0.2rem;\n                    font-size: 0.9rem;\n                }\n\n                p {\n                    font-size: 9px;\n                    white-space: nowrap;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                }\n            }\n\n        }\n\n        .correct-table {\n            background: transparent linear-gradient(-90deg, #FFFFFF 0%, #19cba165 100%) 0% 0% no-repeat;\n\n            .card {\n                box-shadow: 0px 3px 20px #00000029;\n                border-radius: 6px;\n\n                &:not(:last-child) {\n                    margin-right: .3rem;\n                }\n            }\n        }\n\n        .wrong-table {\n            background: transparent linear-gradient(-90deg, #FFFFFF 0%, #f05d7170 100%) 0% 0% no-repeat;\n\n            .card {\n                box-shadow: 0px 3px 20px #00000029;\n                border-radius: 6px;\n\n                &:not(:last-child) {\n                    margin-right: .3rem;\n                }\n            }\n        }\n    }\n\n    .chapterwise-table {\n        .subjects-selection-filter {\n            @media (min-width: 768px) {\n                width: 25%;\n            }\n\n            @media (max-width: 767px) {\n                width: 100%;\n                margin-left: 0 !important;\n                margin-top: .65rem;\n            }\n        }\n\n        .table-fixed thead {\n            width: 98.5%;\n        }\n\n        .table-fixed tbody {\n            height: 250px;\n            overflow-y: auto;\n            width: 100%;\n        }\n\n        @media (min-width: 992px) {\n\n            .table-fixed thead,\n            .table-fixed tbody,\n            .table-fixed tr,\n            .table-fixed td,\n            .table-fixed th {\n                display: flow-root;\n            }\n        }\n\n        @media (min-width: 992px) {\n\n            .table-fixed tbody td,\n            .table-fixed thead>tr>th {\n                float: left;\n                border-bottom-width: 0;\n            }\n        }\n\n        .table {\n\n            tr th,\n            tr td {\n                padding: 8px 18px;\n                border-top: none;\n                text-align: left;\n            }\n\n            tr td:nth-child(1) {\n                text-align: left;\n            }\n\n            tr th:not(:last-child),\n            tr td:not(:last-child) {\n                border-right: 1px solid #dee2e6;\n            }\n\n            thead tr {\n                th {\n                    font-weight: 600;\n                    border-bottom: 1px solid #dee2e6;\n                }\n            }\n\n            tbody {\n\n                tr td {\n                    &:nth-child(1) {\n                        white-space: nowrap;\n                        text-overflow: ellipsis;\n                        overflow: hidden;\n                    }\n\n                    &:nth-child(2) {\n                        color: var(--red);\n                    }\n\n                    &:nth-child(3) {\n                        color: var(--info);\n                    }\n\n                    &:nth-child(4) {\n                        color: var(--green);\n                    }\n\n                    &:nth-child(5) {\n                        color: var(--pink);\n                    }\n\n                    &:nth-child(6) {\n                        color: var(--purple);\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
